export default {
  url: 'https://reactnext-strapi-landing-page.herokuapp.com/pages/?slug=',
  siteName: 'React Landing Page',
  defaultSlug: 'landing-page',
};
